import {DisplayableShareLandTransaction, Land} from 'shareland-common';

export type MessageContent = {
  content: string;
  theme: 'success' | 'warning' | 'error';
  canSubmitForm: boolean;
  actionButtonTitle?: string;
  action?: () => void;
};

export type Balance = {
  balance: number;
};

export const enum TokenType {
  STABLE = 'stable',
  LAND = 'land',
}

export type TokenGroup<T> = {
  [TokenType.STABLE]: T;
  [TokenType.LAND]: T;
};

export type LandAndTransaction = {land: Land; transaction: DisplayableShareLandTransaction};

export type Wishlist = {
  account: string;
  landId: number;
};
